import {Component, Inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {SettingsDataService} from './settings-data.service';
import {interval, Subject} from 'rxjs';
import {Route} from './model/route.model';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'Show Me My Commute';
  settingsDataService: SettingsDataService;

  stopTimer$: Subject<boolean> = new Subject<boolean>();
  source = interval(30 * 1000);

  constructor(private router: Router, settingsDataService: SettingsDataService, public dialog: MatDialog, public location: Location) {
    this.settingsDataService = settingsDataService;

    this.startRefresh();

    this.settingsDataService.stopIdRefresh.subscribe(updateUrl => {
      if (updateUrl) {
        let route = this.settingsDataService.stopIdRoute;
        if (this.settingsDataService.stopIdRoute.split(',').length > 1) {
          route = 'ALL';
        }

        const correctPath = '/' + this.settingsDataService.stopIdProvider +
          '/' + route + '/' + this.settingsDataService.stopId;

        if (!this.location.path().startsWith(correctPath)) {

          this.router.navigate([correctPath], {
            queryParams: {state: '1'},
            queryParamsHandling: 'merge'
          });
        }

      }

    });
  }

  openDialog() {
    console.log('noactivity');
    const dialogRef = this.dialog.open(InactiveComponent, {width: '250px'});
    dialogRef.afterClosed().subscribe(result => {
        this.settingsDataService.activityDetected.emit('reset timer');
        this.settingsDataService.refreshAll.emit();
        this.startRefresh();
      }
    );
  }

  refresh() {
    this.settingsDataService.activityDetected.emit('main button refresh');
    this.settingsDataService.refreshAll.emit();
  }

  remove(route: Route) {
    this.settingsDataService.activityDetected.emit('remove route');
    this.settingsDataService.removeRoute(route);
  }

  goToSettings() {
    this.router.navigate(['/settings']);
  }

  onActivate($event) {
    window.scroll(0, 0);
  }

  setRouteStyle(routeId: string) {
    if (routeId !== null && routeId !== undefined) {
      const color = this.settingsDataService.getColor(routeId);
      return {'background-color': color};
    } else {
      return {};
    }
  }

  private startRefresh() {
    console.log('starting refresh');
    this.source.pipe(takeUntil(this.stopTimer$)).subscribe(val => {
      if (this.settingsDataService.noRecentActivity()) {
        this.stopTimer$.next(true);
        this.openDialog();
      } else {
        console.log('refreshing ' + val);
        this.settingsDataService.refreshAll.emit();
      }
    });
  }
}

@Component({
  selector: 'app-inactive.component',
  template: `
    <div mat-dialog-content style="display:flex; justify-content:center">
      <p>Are you still there?</p>
    </div>
    <div mat-dialog-actions style="display:flex; justify-content:center">
      <button mat-button (click)="onNoClick()" *ngIf="count < 3">No</button>
      <button mat-raised-button color="primary" [mat-dialog-close]="data" cdkFocusInitial>Yes</button>
    </div>

  `
})
export class InactiveComponent implements OnInit {

  count = 0;

  constructor(
    public dialogRef: MatDialogRef<InactiveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string, private snackBar: MatSnackBar) {
  }

  ngOnInit() {
  }

  onNoClick() {
    this.count++;
    switch (this.count) {
      case 1:
        this.snackBar.open('Ok, I am ignoring you', 'Ok', {duration: 10000});
        break;
      case 2:
        this.snackBar.open('I heard you the first time. Stop it!', 'Ok', {duration: 10000});
        break;
      case 3:
        this.snackBar.open('Fine. You are the weakest link, goodbye', 'Ok', {duration: 10000});
        break;
    }

  }
}
